import React from 'react';
import PropTypes from 'prop-types';

import Pagination from '@grupa-pracuj/react-pagination';
import 'src/components/Pagination/ScrollContainer.scss';


const ScrollContainer = ({ children }) => (
  <Pagination.ScrollContainer render={ ({ reference, onScroll }) => (
    <div
      ref={ reference }
      data-test="scroll-paginationArea"
      onScroll={ onScroll }
      styleName="scroll-container"
    >
      {children}
    </div>
  ) }
  />
);


ScrollContainer.propTypes = {
  children: PropTypes.node.isRequired
};


export default ScrollContainer;
